var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ButtonPrimary, ButtonSecondary, ContentBox, H2, H5 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { MileageStyle } from './MileageStyle';
import { DynamicTitle } from '../DynamicTitle';
import { QQMilesInput } from './QQMilesInput';
import { eventSection } from '../../utils/event';
export var Mileage = function (_a) {
    var mileageProps = _a.mileageProps;
    var _b = useState((mileageProps === null || mileageProps === void 0 ? void 0 : mileageProps.estimated_mileage) || 0), updatedMileage = _b[0], setUpdatedMileage = _b[1];
    var estimated_mileage = mileageProps.estimated_mileage, annualEstimate = mileageProps.annualEstimate, step = mileageProps.step, updateState = mileageProps.updateState, updateMileage = mileageProps.updateMileage, vehicle = mileageProps.vehicle, stateUpdateMileage = mileageProps.stateUpdateMileage, isQQPage = mileageProps.isQQPage, isMOTFlow = mileageProps.isMOTFlow, imageSrc = mileageProps.imageSrc;
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'mileage',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    useEffect(function () {
        if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.estimated_mileage) === 0) {
            updateState({ stateName: 'updateMileage', value: true });
        }
    }, []);
    var milesInputState = {
        estimated_mileage: estimated_mileage,
        annualEstimate: annualEstimate,
        step: step,
    };
    return (_jsxs(MileageStyle, __assign({ isQQPage: isQQPage }, { children: [_jsx(DynamicTitle, { className: "enter-details-title mileage-title", icon: _jsx("img", { className: "car-image", src: imageSrc, alt: "" }), title: _jsx("span", { children: isMOTFlow
                        ? "Get a quick quote for your ".concat(vehicle.bymiles_make, " ").concat(vehicle.bymiles_model, ".")
                        : "We\u2019ve found your ".concat(vehicle.bymiles_make, " ").concat(vehicle.bymiles_model, ". Nice wheels!") }), description: "Our policies are pay-as-you-go, so the less you drive, the less you pay. Give us an idea of your mileage and we'll work out your estimated cost for the year.", isQQPage: isQQPage }), _jsx(ContentBox, __assign({ isQQPage: isQQPage, className: "box" }, { children: stateUpdateMileage ? (_jsxs(_Fragment, { children: [_jsx(QQMilesInput, { className: "edit-mileage", onBlur: function () {
                                updateMileage(parseInt(updatedMileage));
                                DataLayer.customEvent({
                                    eventName: 'change miles estimate',
                                    eventType: 'form tracking',
                                    section: "".concat(eventSection(isQQPage), " update mileage"),
                                });
                            }, onChange: function (mileage) { return setUpdatedMileage(mileage); }, milesInputState: milesInputState, isQQPage: isQQPage }), _jsx(ButtonPrimary, { label: "Continue", iconRight: "IconCaretRight", className: "button-mileage", onClick: function () {
                                updateState({ stateName: 'step', value: 2 });
                                DataLayer.customEvent({
                                    eventName: 'submit changed miles',
                                    eventType: 'button click',
                                    section: "".concat(eventSection(isQQPage), " mileage"),
                                });
                            } })] })) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "mileage-label" }, { children: "Last year we think your car travelled" })), _jsxs(H2, __assign({ className: "heading-padding" }, { children: [vehicle.estimated_mileage > 0
                                    ? vehicle.estimated_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    : 0, ' ', "miles"] })), _jsx(H5, __assign({ className: "heading-padding" }, { children: "Will you drive the same this year?" })), _jsxs("div", __assign({ className: "buttons-wrapper" }, { children: [_jsx(ButtonSecondary, { className: "mileage-change", label: "change", onClick: function () {
                                        updateState({ stateName: 'updateMileage', value: true });
                                        DataLayer.customEvent({
                                            eventName: 'edit estimated miles',
                                            eventType: 'button click',
                                            section: "".concat(eventSection(isQQPage), " mileage"),
                                        });
                                    } }), _jsx(ButtonPrimary, { className: "mileage-confirm", iconRight: "IconCaretRight", label: "continue", onClick: function () {
                                        updateState({ stateName: 'step', value: 2 });
                                        DataLayer.customEvent({
                                            eventName: 'submit miles estimate',
                                            eventType: 'button click',
                                            section: "".concat(eventSection(isQQPage), " mileage"),
                                        });
                                    } })] })), _jsx("div", __assign({ className: "mileage-by" }, { children: "Mileage data from the DVLA" }))] })) }))] })));
};
export default Mileage;
